<dv-dropdown
  #search
  class="route-network-search-dropdown"
  [rowHeight]="38"
  [datasource]="dataSource"
  [columns]="dropdownColumns"
  [disableSearchFiltering]="true"
  [loadingText]="'General.LoadingOoo' | translate"
  [noItemsText]="'Map.SearchToSeeResult' | translate"
  [placeholder]="'Map.FindRouteNetworks' | translate"
  [isClearable]="false"
  (valueChange)="onRouteNetworkSelected($event)"
  (isOpenChange)="searchPanelToggled($event)"
/>
